// @flow
import * as React from 'react';
// eslint-disable-next-line import/named
import { type IntlShape } from 'react-intl';

// Components
import { Row, Col } from 'reactstrap';
import Panel from 'components/atoms/Panel';
import VehicleImageWithPlaceholder from 'components/atoms/VehicleImageWithPlaceholder';

// Utils
import { getVehicleImgUrl } from 'utils/media';
import { getMMLabel } from 'utils/string';

// Types
import { type VehicleInfo } from 'api/xws/statusTracker/statusTrackerWs';

import './VehiclePanel.scss';

const ns = 'vehicle-panel';

export type Props = {
  vehicleInfo?: VehicleInfo,
  dealerCountryCode: string,
  intl: IntlShape,
  advisor?: string,
  transportation?: string,
  externalValet: string,
  intl: IntlShape,
  modelLabelOther?: string,
  makeLabelOther?: string
};

const VehiclePanel = ({
  vehicleInfo,
  dealerCountryCode,
  intl,
  advisor,
  transportation,
  externalValet,
  modelLabelOther,
  makeLabelOther
}: Props) => {
  return (
    <Row className={`${ns} mx-0`}>
      <Panel className={`${ns}__panel`}>
        <Col xs={7} sm={7}>
          <div className={`${ns}__info-vehicle`}>
            <span className={`mr-1`}>
              {vehicleInfo && vehicleInfo.year}{' '}
              {vehicleInfo &&
                getMMLabel(vehicleInfo.make, makeLabelOther, intl)}
            </span>
            <span className={`${ns}__info-vehicle--model`}>
              {vehicleInfo &&
                getMMLabel(vehicleInfo.model, modelLabelOther, intl)}
            </span>
          </div>
          <div className={`${ns}__info-text`}>{advisor}</div>
          {!externalValet && (
            <div className={`${ns}__info-text`}>{transportation}</div>
          )}
        </Col>
        <Col xs={5} sm={5} className={`${ns}__vehicle`}>
          <VehicleImageWithPlaceholder
            src={getVehicleImgUrl(vehicleInfo, dealerCountryCode)}
          />
        </Col>
      </Panel>
    </Row>
  );
};

VehiclePanel.defaultProps = {
  vehicleInfo: {
    year: null,
    make: null,
    model: null
  }
};

export default VehiclePanel;



// WEBPACK FOOTER //
// ./src/components/atoms/VehiclePanel/VehiclePanel.js